import { createTV } from 'tailwind-variants'
import { FONT_SIZE_CLASS_GROUP } from './text-scale.ts'

/**
 * The configured `tv` every component in this package must import — never `tv` from
 * `tailwind-variants` directly.
 *
 * tailwind-variants runs tailwind-merge internally when it composes base + variant classes, and
 * tailwind-merge only knows the stock font sizes (`text-sm`, `text-lg`…). Our scale is custom, so
 * without this config it classifies `text-ui` / `text-body` as text *colours*, decides they
 * conflict with a real colour like `text-text-inverse`, and silently drops one — which renders
 * ink text on an ink button, or a badge at the inherited 16px. No error, no warning.
 *
 * The scale itself lives in text-scale.ts and is checked against theme.css by a test.
 */
export const tv = createTV({
  twMergeConfig: { extend: { classGroups: FONT_SIZE_CLASS_GROUP } },
})

export type { VariantProps } from 'tailwind-variants'
